import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { RestrictionFeature } from "../../types";
import { useGetBookingRestrictionStatusesFragment$key } from "./__generated__/useGetBookingRestrictionStatusesFragment.graphql";

export const useGetBookingRestrictionStatuses = ({
  fragmentRef,
}: {
  fragmentRef: useGetBookingRestrictionStatusesFragment$key | null;
}) => {
  const data = useFragment(
    useGetBookingRestrictionStatusesFragmentString,
    fragmentRef
  );

  const isLessonBooking = data?.__typename === "LessonBooking";

  const newRoundRestrictions: (
    | RestrictionFeature.RestrictionBarData
    | undefined
  )[][] =
    data?.restrictionStatuses?.roundStatuses?.map((rs) => {
      return (
        rs?.statuses?.flatMap((s) => {
          if (isLessonBooking) {
            return isValidLessonRestriction(s) ? (s !== null ? s : []) : [];
          } else {
            return s ? s : [];
          }
        }) ?? []
      );
    }) ?? [];
  const newGroupRestrictions: (
    | RestrictionFeature.RestrictionBarData
    | undefined
  )[] =
    data?.restrictionStatuses?.groupStatuses?.statuses?.flatMap((s) => {
      if (isLessonBooking) {
        return isValidLessonRestriction(s) ? (s !== null ? s : []) : [];
      } else {
        return s ? s : [];
      }
    }) ?? [];

  return {
    roundRestrictions: newRoundRestrictions,
    groupRestrictions: newGroupRestrictions,
  };
};

const isValidLessonRestriction = (
  s: RestrictionFeature.RestrictionBarData | null | undefined
): boolean => {
  return (
    !!s &&
    s.rule.__typename === "BookingRestrictionRule" &&
    s.rule.bookingType === "LESSON"
  );
};

const useGetBookingRestrictionStatusesFragmentString = graphql`
  fragment useGetBookingRestrictionStatusesFragment on Booking {
    __typename
    restrictionStatuses {
      groupStatuses {
        statuses {
          count
          willViolate
          rule {
            __typename
            id
            name
            ... on BookingRestrictionRule {
              bookingType
              displayName
              memberMessage
              memberOverride
              staffOverride
              countLimit {
                countLimit
                countUnit
                qualifier
                timeLimit
                timeUnit
                showNonViolating
              }
              bookingCriteria {
                minPlayers
                maxPlayers
              }
            }
          }
        }
      }
      roundStatuses {
        statuses {
          count
          willViolate
          rule {
            __typename
            id
            name
            ... on BookingRestrictionRule {
              bookingType
              displayName
              memberMessage
              memberOverride
              staffOverride
              countLimit {
                countLimit
                countUnit
                qualifier
                timeLimit
                timeUnit
                showNonViolating
              }
              bookingCriteria {
                minPlayers
                maxPlayers
              }
            }
          }
        }
      }
    }
  }
`;
